import { AppModule } from 'app/module';
import './styles.scss';
import Template from './template.hbs';

export class BlogBox extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }
}
